// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_3Oq4P","wrapperInner":"style_wrapperInner_372H8"};